// src/app/components/mi-map/mi-map.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export type CountyStatus = 'captain' | 'active' | 'none';

export interface MapCounty {
  name: string;
  status: CountyStatus;
}

@Component({
  selector: 'app-mi-map',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './mi-map.component.html',
  styleUrls: ['./mi-map.component.css'],
})
export class MiMapComponent {
  // Update status as captains sign up:
  // 'captain' = has a constitutional captain
  // 'active'  = canvassing underway, no formal captain yet
  // 'none'    = needs coverage
  counties: MapCounty[] = [
    // Upper Peninsula
    { name: 'Gogebic',     status: 'captain' },
    { name: 'Ontonagon',   status: 'none' },
    { name: 'Houghton',    status: 'none' },
    { name: 'Keweenaw',    status: 'none' },
    { name: 'Baraga',      status: 'captain' },
    { name: 'Iron',        status: 'none' },
    { name: 'Dickinson',   status: 'none' },
    { name: 'Menominee',   status: 'none' },
    { name: 'Marquette',   status: 'active' },
    { name: 'Alger',       status: 'none' },
    { name: 'Schoolcraft', status: 'none' },
    { name: 'Delta',       status: 'none' },
    { name: 'Luce',        status: 'captain' },
    { name: 'Chippewa',    status: 'none' },
    { name: 'Mackinac',    status: 'none' },
    // Northern Lower
    { name: 'Emmet',       status: 'none' },
    { name: 'Cheboygan',   status: 'none' },
    { name: 'Presque Isle',status: 'none' },
    { name: 'Charlevoix',  status: 'none' },
    { name: 'Antrim',      status: 'none' },
    { name: 'Otsego',      status: 'none' },
    { name: 'Montmorency', status: 'none' },
    { name: 'Alpena',      status: 'active' },
    { name: 'Benzie',      status: 'none' },
    { name: 'Leelanau',    status: 'none' },
    { name: 'Grand Traverse', status: 'active' },
    { name: 'Kalkaska',    status: 'none' },
    { name: 'Crawford',    status: 'none' },
    { name: 'Oscoda',      status: 'active' },
    { name: 'Alcona',      status: 'none' },
    { name: 'Manistee',    status: 'none' },
    { name: 'Wexford',     status: 'none' },
    { name: 'Missaukee',   status: 'none' },
    { name: 'Roscommon',   status: 'none' },
    { name: 'Ogemaw',      status: 'none' },
    { name: 'Iosco',       status: 'none' },
    // Mid Lower
    { name: 'Mason',       status: 'none' },
    { name: 'Lake',        status: 'none' },
    { name: 'Osceola',     status: 'active' },
    { name: 'Clare',       status: 'none' },
    { name: 'Gladwin',     status: 'none' },
    { name: 'Arenac',      status: 'none' },
    { name: 'Bay',         status: 'none' },
    { name: 'Huron',       status: 'captain' },
    { name: 'Oceana',      status: 'none' },
    { name: 'Newaygo',     status: 'none' },
    { name: 'Mecosta',     status: 'none' },
    { name: 'Isabella',    status: 'none' },
    { name: 'Midland',     status: 'captain' },
    { name: 'Tuscola',     status: 'none' },
    { name: 'Sanilac',     status: 'none' },
    // Southwest/Central Lower
    { name: 'Muskegon',    status: 'none' },
    { name: 'Montcalm',    status: 'none' },
    { name: 'Gratiot',     status: 'none' },
    { name: 'Saginaw',     status: 'none' },
    { name: 'Ottawa',      status: 'none' },
    { name: 'Kent',        status: 'none' },
    { name: 'Ionia',       status: 'none' },
    { name: 'Clinton',     status: 'none' },
    { name: 'Shiawassee',  status: 'none' },
    { name: 'Genesee',     status: 'captain' },
    { name: 'Lapeer',      status: 'none' },
    { name: 'St. Clair',   status: 'active' },
    { name: 'Allegan',     status: 'none' },
    { name: 'Barry',       status: 'none' },
    { name: 'Eaton',       status: 'none' },
    { name: 'Ingham',      status: 'none' },
    { name: 'Livingston',  status: 'none' },
    { name: 'Macomb',      status: 'captain' },
    { name: 'Oakland',     status: 'none' },
    // Southern Lower
    { name: 'Van Buren',   status: 'none' },
    { name: 'Kalamazoo',   status: 'none' },
    { name: 'Calhoun',     status: 'none' },
    { name: 'Jackson',     status: 'none' },
    { name: 'Washtenaw',   status: 'none' },
    { name: 'Wayne',       status: 'active' },
    { name: 'Berrien',     status: 'none' },
    { name: 'Cass',        status: 'none' },
    { name: 'St. Joseph',  status: 'active' },
    { name: 'Branch',      status: 'none' },
    { name: 'Hillsdale',   status: 'none' },
    { name: 'Lenawee',     status: 'none' },
    { name: 'Monroe',      status: 'none' },
  ];

  selectedCounty: MapCounty | null = null;

  get captainCount(): number { return this.counties.filter(c => c.status === 'captain').length; }
  get activeCount(): number  { return this.counties.filter(c => c.status === 'active').length; }
  get noneCount(): number    { return this.counties.filter(c => c.status === 'none').length; }

  get captainCounties(): MapCounty[] { return this.counties.filter(c => c.status === 'captain'); }
  get activeCounties(): MapCounty[]  { return this.counties.filter(c => c.status === 'active'); }
  get openCounties(): MapCounty[]    { return this.counties.filter(c => c.status === 'none'); }

  select(county: MapCounty): void {
    this.selectedCounty = this.selectedCounty?.name === county.name ? null : county;
  }

  statusLabel(s: CountyStatus): string {
    if (s === 'captain') return 'Has Captain';
    if (s === 'active')  return 'Canvassing';
    return 'Needs Captain';
  }
}
